import React, { useEffect, useState } from "react";
import PageTitle from "../../common/PageTitle";
import { checkAuthority } from "../../utils";
import SiteDetailCard from "../../components/sites/DetailCard";
import "./Fsr.css";
import { Helmet } from "react-helmet";

const Fsr = () => {
  const [fsrList, setFsrList] = useState([]);

  const pathname = window.location?.pathname;
  const baseRoute = pathname?.split("/")[1] === "company" ? "/company" : "";

  const permissionList =
    JSON.parse(localStorage.getItem("permisionlist")) || [];

  const submenuPermissions = permissionList[0]?.submenuPermissions || [];

  const hasPermission = (title) =>
    submenuPermissions.some((perm) => perm.submenu === title);

  const getManagementDetails = () => {
    const menuItems = [];

    if (submenuPermissions.length === 0) {
      menuItems.push(
        {
          id: 1,
          title: "Facility Service Requests",
          url: `${baseRoute}/fsr/facilities`,
        },
        {
          id: 2,
          title: "Facility Settings",
          url: `${baseRoute}/fsr/settings`,
        },
        {
          id: 3,
          title: "FSR Dashboard",
          url: `${baseRoute}/fsr/dashboard`,
        },
        {
          id: 4,
          title: "Surveys",
          url: `${baseRoute}/fsr/surveys`,
        }
      );
    } else {
      if (
        checkAuthority("VIEW_FACILITY_SERVICE_REQUESTS") &&
        hasPermission("Facility Service Requests")
      ) {
        menuItems.push({
          id: 1,
          title: "Facility Service Requests",
          url: `${baseRoute}/fsr/facilities`,
        });
      }

      if (
        checkAuthority("VIEW_FACILITY_SETTINGS") &&
        hasPermission("Facility Settings")
      ) {
        menuItems.push({
          id: 2,
          title: "Facility Settings", // fixed title match
          url: `${baseRoute}/fsr/settings`,
        });
      }

      if (
        checkAuthority("VIEW_FACILITY_SERVICE_REQUESTS") &&
        hasPermission("FSR Dashboard")
      ) {
        menuItems.push({
          id: 3,
          title: "FSR Dashboard",
          url: `${baseRoute}/fsr/dashboard`,
        });
      }

      if (
        checkAuthority("VIEW_FACILITY_SERVICE_REQUESTS") &&
        hasPermission("Surveys")
      ) {
        menuItems.push({
          id: 4, // unique ID fixed
          title: "Surveys",
          url: `${baseRoute}/fsr/surveys`,
        });
      }
    }

    setFsrList(menuItems);
  };

  useEffect(() => {
    getManagementDetails();
  }, [pathname]);

  return (
    <div>
      <Helmet>
        <title>Facility Service Requests</title>
      </Helmet>
      <PageTitle title={"FSR"} />
      <div className="datacard">
        {fsrList.length > 0 ? (
          fsrList.map((fsr) => (
            <SiteDetailCard key={fsr.id} title={fsr.title} url={fsr.url} />
          ))
        ) : (
          <div className="empty-state">No FSR options available.</div>
        )}
      </div>
    </div>
  );
};

export default Fsr;
